module.exports = __webpack_public_path__ + "static/media/crash_2.548946a2.mp3";